module.exports = __webpack_public_path__ + "media/images/icons/twotone/calculator-6577354dfc8e720aecae477698e70017.svg";